import { render, staticRenderFns } from "./WelcomeHeader.vue?vue&type=template&id=1aaca192&scoped=true"
import script from "./WelcomeHeader.vue?vue&type=script&lang=js"
export * from "./WelcomeHeader.vue?vue&type=script&lang=js"
import style0 from "./WelcomeHeader.vue?vue&type=style&index=0&id=1aaca192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaca192",
  null
  
)

export default component.exports